import React from "react";
import { UseFormRegisterReturn } from "react-hook-form";

interface DayInputFieldProps {
    register: UseFormRegisterReturn;
    value?: string;
    error?: string;
    disabled?: boolean;
    id?: string;
    onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
    onBlur: () => void;
}

/**
 * Day input field component with numeric validation
 */
const DayInputField = ({ register, value, error, disabled, id, onChange, onBlur }: DayInputFieldProps) => {
    return (
        <div className="form-control w-fit">
            <label className="label h-6" htmlFor={id}>
                <span className="text-base-content text-xs font-bold leading-4">Day</span>
            </label>
            <input
                {...register}
                onChange={onChange}
                onBlur={onBlur}
                type="text"
                className={`input input-bordered bg-base-100 w-[40px] h-9 text-sm pl-2 pr-3 ${
                    disabled ? "opacity-50 cursor-not-allowed" : ""
                } ${error ? "input-error" : ""}`}
                disabled={disabled}
                value={value || ""}
                maxLength={2}
                id={id}
            />
        </div>
    );
};

export default DayInputField;
